module.exports = __webpack_public_path__ + "static/media/travly-logo.a4fac2e6.svg";